import { createStore, compose, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { persistStore } from 'redux-persist';
import rootReducer from '../reducers/rootReducer';
import defaultState from './defaultState';
import rootSaga from '../sagas/rootSaga';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  defaultState,
  compose(applyMiddleware(sagaMiddleware, createLogger()))
);

export const persistor = persistStore(store);

if (module.hot) {
  module.hot.accept('../reducers/rootReducer', () => {
    const nextRootReducer = require('../reducers/rootReducer').default;
    store.replaceReducer(nextRootReducer);
  });
}

sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./src/_app/store/configureStore.prod.js